import React from "react";
// export default props => <svg style={props.style} width={props.width} height={props.height} xmlns="https://www.w3.org/2000/svg" viewBox="0 0 32 32"><path stroke={props.color} fill={props.fill} d="M 11 5 C 9.363281 5 8.136719 6.210938 7.3125 7.5625 C 6.488281 8.914063 6 10.515625 6 12 C 6 14.582031 7.78125 16.464844 10 16.90625 L 10 28 L 12 28 L 12 16.90625 C 14.21875 16.464844 16 14.582031 16 12 C 16 10.515625 15.511719 8.914063 14.6875 7.5625 C 13.863281 6.210938 12.636719 5 11 5 Z M 18 5 L 18 12 C 18 13.851563 19.28125 15.398438 21 15.84375 L 21 28 L 23 28 L 23 15.84375 C 24.71875 15.398438 26 13.851563 26 12 L 26 5 L 24 5 L 24 12 C 24 13.117188 23.117188 14 22 14 C 20.882813 14 20 13.117188 20 12 L 20 5 Z M 21 5 L 21 12 C 21 12.550781 21.449219 13 22 13 C 22.550781 13 23 12.550781 23 12 L 23 5 Z M 11 7 C 11.574219 7 12.34375 7.566406 12.96875 8.59375 C 13.59375 9.621094 14 10.996094 14 12 C 14 14.003906 12.75 15 11 15 C 9.25 15 8 14.003906 8 12 C 8 10.996094 8.40625 9.621094 9.03125 8.59375 C 9.65625 7.566406 10.425781 7 11 7 Z" /></svg>
export default (props) => (
  <svg
    width={props.width || "119"}
    height={props.height || "75"}
    viewBox="0 0 225 208"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="6.30811"
      y="126.859"
      width="213.168"
      height="24.9563"
      fill="#0097CD"
    />
    <rect
      x="6.30811"
      y="5.20703"
      width="213.168"
      height="117.502"
      fill="white"
    />
    <path
      d="M137.62 158.077V182.545C141.104 183.044 144.411 183.169 147.509 184.032C155.578 186.288 161.516 193.661 162.223 201.709C162.577 205.733 161.152 208 156.785 208C127.17 207.969 97.5448 207.969 67.93 208C63.5315 208 62.1901 205.66 62.5437 201.667C63.4067 191.924 71.8087 183.792 81.8536 183.075C83.5277 182.961 85.2226 183.054 87.1568 183.054V158.067C85.337 158.067 83.5173 158.067 81.6976 158.067C59.8713 158.067 38.0449 158.077 16.2186 158.067C5.15466 158.067 0.0698242 152.971 0.0698242 141.887C0.0698242 99.9706 0.0698242 58.0545 0.0698242 16.1384C0.0802227 5.07444 5.17546 0 16.2706 0C80.3562 0 144.452 0 208.538 0C219.612 0 224.697 5.08484 224.697 16.1696C224.707 58.0857 224.707 100.002 224.697 141.918C224.697 152.971 219.591 158.056 208.507 158.056C186.857 158.077 165.207 158.056 143.548 158.056H137.631L137.62 158.077ZM112.383 8.33955C80.6785 8.33955 48.9633 8.33955 17.2584 8.33955C9.6052 8.33955 8.41977 9.48338 8.41977 16.9287C8.41977 58.3353 8.41977 99.7522 8.41977 141.159C8.41977 148.573 9.62599 149.738 17.2688 149.738C80.6889 149.738 144.099 149.738 207.519 149.738C215.162 149.738 216.357 148.573 216.357 141.148C216.357 99.7418 216.357 58.3249 216.357 16.9183C216.357 9.50418 215.151 8.34995 207.498 8.34995C175.793 8.34995 144.078 8.34995 112.373 8.34995L112.383 8.33955ZM128.782 158.358H96.089V182.649H128.782V158.358ZM71.6527 199.317H153.114C150.462 194.097 146.75 191.414 141.457 191.394C122.075 191.321 102.692 191.321 83.3093 191.394C78.0269 191.414 74.2939 194.087 71.6527 199.307V199.317Z"
      fill="black"
    />
    <path
      d="M128.782 158.363V182.654H96.0896V158.363H128.782Z"
      fill="#0097CD"
    />
    <path
      d="M71.6528 199.316C74.294 194.085 78.0167 191.423 83.3095 191.402C102.692 191.319 122.075 191.33 141.458 191.402C146.761 191.423 150.463 194.106 153.114 199.326H71.6528V199.316Z"
      fill="#0097CD"
    />
    <path
      d="M41.6742 65.2585C41.799 46.8844 56.8768 32.0874 75.334 32.2434C93.6768 32.3994 108.443 47.5603 108.224 66.0279C108.006 84.142 93.0425 98.835 74.8349 98.7934C56.5024 98.7622 41.5599 83.6429 41.6742 65.2585ZM70.7795 41.3732C57.6982 43.3281 48.8284 55.1096 50.0762 68.0764C51.3448 81.2825 63.1782 91.2234 76.6442 90.4227C88.2281 89.726 98.8345 79.8267 98.5849 69.6882C91.3476 69.6882 84.0999 69.5738 76.8522 69.7298C72.3808 69.8234 70.6339 67.8477 70.7275 63.4699C70.8835 56.2326 70.7691 48.9849 70.7691 41.3732H70.7795ZM79.3686 41.4876V61.0679H98.98C97.7218 50.8774 89.663 42.7978 79.3686 41.4876Z"
      fill="black"
    />
    <path
      d="M160.103 44.7261C155.787 44.7261 151.409 45.142 147.177 44.5493C145.17 44.2686 143.434 42.0433 141.573 40.7019C143.34 39.2669 145.056 36.6881 146.886 36.5945C155.85 36.1682 164.844 36.189 173.808 36.5841C175.555 36.6569 177.187 39.0797 178.882 40.4211C177.114 41.8561 175.482 44.2582 173.548 44.5285C169.149 45.1524 164.595 44.7261 160.103 44.7261Z"
      fill="black"
    />
    <path
      d="M160.103 69.6636C155.787 69.6636 151.409 70.0795 147.177 69.4868C145.17 69.2061 143.434 66.9808 141.573 65.6394C143.34 64.2044 145.056 61.6256 146.886 61.532C155.85 61.1057 164.844 61.1265 173.808 61.5216C175.555 61.5944 177.187 64.0172 178.882 65.3586C177.114 66.7936 175.482 69.1957 173.548 69.466C169.149 70.0899 164.595 69.6636 160.103 69.6636Z"
      fill="black"
    />
    <path
      d="M160.362 94.6167C156.047 94.6167 151.731 94.5751 147.416 94.6375C144.328 94.6791 141.291 93.8784 141.842 90.3845C142.092 88.7832 145.222 86.5683 147.135 86.4747C155.922 86.0588 164.75 86.0484 173.537 86.4851C175.377 86.5787 177.093 89.1471 178.871 90.5717C177.02 91.9235 175.294 94.1592 173.287 94.4399C169.055 95.043 164.677 94.6271 160.362 94.6271V94.6167Z"
      fill="black"
    />
    <path
      d="M134.959 40.7878C132.026 42.5868 130.29 44.4897 128.699 44.3857C127.357 44.2921 124.935 41.4949 125.205 40.5383C125.673 38.9161 127.763 36.982 129.416 36.7116C130.654 36.5141 132.286 38.7081 134.959 40.7878Z"
      fill="black"
    />
    <path
      d="M129.011 71.4674C127.097 68.6078 125.142 66.944 125.184 65.3531C125.226 64.0117 127.908 61.4641 128.865 61.7032C130.508 62.1192 132.525 64.1053 132.858 65.7482C133.108 66.9856 130.986 68.7014 129.011 71.4778V71.4674Z"
      fill="black"
    />
    <path
      d="M128.928 96.4001C127.067 93.5093 125.132 91.8248 125.195 90.2234C125.257 88.882 127.982 86.376 128.938 86.6359C130.581 87.0727 132.557 89.1004 132.869 90.7433C133.098 91.9807 130.945 93.6653 128.928 96.4001Z"
      fill="black"
    />
    <path
      d="M70.7791 41.375C70.7791 48.9867 70.8935 56.224 70.7375 63.4717C70.6439 67.839 72.3909 69.8251 76.8622 69.7315C84.1099 69.5756 91.3576 69.69 98.5949 69.69C98.8445 79.8284 88.2277 89.7381 76.6542 90.4244C63.1882 91.2355 51.3548 81.2842 50.0862 68.0782C48.8384 55.1113 57.6979 43.3195 70.7895 41.375H70.7791Z"
      fill="#FFB718"
    />
    <path
      d="M79.3687 41.4727C89.6631 42.7829 97.7115 50.8624 98.9801 61.0529H79.3687V41.4727Z"
      fill="#0097CD"
    />
    <rect
      x="6.30811"
      y="122.699"
      width="213.168"
      height="8.31875"
      fill="black"
    />
  </svg>
);
